import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTemp } from 'swipeclock-frontend';
import WarningIcon from '@mui/icons-material/Warning';
import { useTheme } from '@mui/material/styles';
import PoweredByFooter from './shared/PoweredByFooter';
import { useWhiteLabelContext } from 'providers/WhiteLabelProvider';

// Shared components
import PromptContentCard from './shared/PromptContentCard';
import ActionButton from './shared/ActionButton';
import { useCountdown } from '../hooks/useTimer';
import {
  HeaderStack,
  CountdownProgress,
  TimerText,
  TitleText,
  MessageText,
} from './shared/PromptStyled';

export default function PromptWarning() {
  const history = useHistory();
  const theme = useTheme();
  const { state: whiteLabelState } = useWhiteLabelContext();

  // Redirects to the clock page after 30 seconds
  const { timeLeft, progressPercentage } = useCountdown(30, () =>
    history.push('/clock/web')
  );

  return (
    <>
      <PromptContentCard
        accentColor={{
          main: theme.palette.warning.main,
          light: theme.palette.warning.light,
        }}
      >
        <Prompt />
        <CountdownProgress
          variant="determinate"
          value={progressPercentage}
          color={{
            main: theme.palette.warning.main,
            light: theme.palette.warning.light,
          }}
        />
        <TimerText variant="caption">{timeLeft}s</TimerText>
      </PromptContentCard>
      <PoweredByFooter whiteLabelState={whiteLabelState} />
    </>
  );
}

// #########################
// ### Child Components ###
// #########################

const Prompt = React.memo(function Prompt() {
  const { temp: cache } = useTemp('webClock');

  const { warning } = cache || {};
  const title = 'Warning';
  const message =
    warning ||
    'There is a warning with your punch request. Please confirm to continue.';

  return (
    <>
      <HeaderStack>
        <WarningIcon fontSize="large" sx={{ color: '#ff9800' }} />
        <TitleText variant="h4">{title}</TitleText>
      </HeaderStack>
      <MessageText variant="h5">{message}</MessageText>
      <ActionButton
        id="sc-warning_return_to_clock_button"
        to="/clock/web"
        color={{ dark: '#f57c00', main: '#ff9800' }}
      >
        RETURN TO CLOCK
      </ActionButton>
    </>
  );
});
